import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from './MetaPixel';
export function Pricing() {
  return <section className="py-24 md:py-32 bg-ink-light relative border-y border-white/5" data-id="element-272" data-mp="2oipjx0chn5gh">
      <div className="container mx-auto px-6" data-id="element-273" data-mp="2okjwnrdlvr9h">
        <motion.div className="max-w-3xl mx-auto text-center" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-274" data-mp="2jknpxkdixlq8">
          <div className="bg-ink border border-gold/30 rounded-3xl p-8 md:p-12 relative overflow-hidden shadow-2xl" data-id="element-275" data-mp="1rut1dpxhq02m">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-276" data-mp="20tegfb3r6wyn"></div>
            
            <div className="mb-10" data-id="element-277" data-mp="3h63a8flol2rm">
              <span className="inline-block text-muted text-sm tracking-widest uppercase font-semibold mb-2" data-id="element-278" data-mp="3h9haniasb1wf">
                VALOR FUTURO DEL PROGRAMA
              </span>
              <div className="text-muted/50 font-serif text-3xl line-through decoration-white/20 mb-8" data-id="element-279" data-mp="3vyx96505i8ho">
                USD 97
              </div>

              <div className="mb-8" data-id="element-280" data-mp="9si7fusw8azk">
                <h3 className="text-2xl font-serif text-ivory-bright mb-3 uppercase" data-id="element-281" data-mp="9tjw522u0vzr">PRIMERA EDICIÓN — RECUPERA TU VIDA</h3>
                <p className="text-muted font-light max-w-xl mx-auto" data-id="element-282" data-mp="eqk1faruxupt">
                  Estoy abriendo los primeros 10 lugares para acompañar personalmente esta primera edición, recoger experiencias reales y perfeccionar el método.
                </p>
              </div>

              <div className="inline-flex flex-col items-center mb-6" data-id="element-283" data-mp="3n63p7u9rekxh">
                <span className="bg-gold/10 text-gold text-xs tracking-[0.1em] uppercase font-bold px-6 py-2 rounded-t-lg border-x border-t border-gold/30 w-full text-center" data-id="element-284" data-mp="3ryded831vgyp">
                  10 LUGARES DISPONIBLES
                </span>
                <span className="inline-block text-ivory-bright text-sm tracking-[0.2em] uppercase font-semibold px-6 py-2 border border-gold/30 rounded-b-lg rounded-t-none bg-ink w-full" data-id="element-285" data-mp="2zfznjsg4sv94">
                  PRECIO BETA
                </span>
              </div>

              <div className="flex items-baseline justify-center gap-4 flex-wrap" data-id="element-286" data-mp="3177i2zm15dgp">
                <span className="font-serif text-6xl md:text-8xl text-ivory-bright leading-none" data-id="element-287" data-mp="2w7uwsjat4eg8">
                  USD 30
                </span>
                <span className="text-muted text-2xl font-serif italic" data-id="element-288" data-mp="28is8wtpkxpda">o</span>
                <span className="font-serif text-5xl md:text-6xl text-gold leading-none" data-id="element-289" data-mp="23jp85lgmu5b4">
                  $30.000
                </span>
              </div>
              <span className="text-muted text-sm tracking-widest uppercase block mt-4" data-id="element-290" data-mp="2idtxnofy0pfc">
                ARS
              </span>
            </div>

            <div className="text-muted font-light leading-relaxed mb-10 max-w-xl mx-auto" data-id="element-291" data-mp="3tuaglrqpho6y">
              <p className="text-ivory/90 font-medium mb-4" data-id="element-292" data-mp="3ov781xbiozu8">
                Tu inscripción incluye el programa completo de 30 días, sesión estratégica 1 a 1, seguimiento, diagnóstico inicial y final, plan de próximos 30 días y los 4 bonos de la primera edición.
              </p>
              <p data-id="element-293" data-mp="3nflaudd2hmfg">Después de esta primera edición, el valor del programa será de USD 97.</p>
            </div>

            <a href="https://wa.me/5491145263003" target="_blank" rel="noopener noreferrer" onClick={trackWhatsAppClick} className="w-full md:w-auto inline-flex items-center justify-center gap-3 px-10 py-5 bg-[#25D366] text-white hover:bg-[#1DA851] transition-colors duration-300 font-medium tracking-wide shadow-lg shadow-[#25D366]/20 rounded-xl text-lg" data-id="element-294" data-mp="3rfwv3p1ipkqe">
              <MessageCircle className="w-6 h-6" data-id="element-295" data-mp="e8byjtlnplxg" />
              QUIERO RECUPERAR MI VIDA
            </a>
            
            <p className="mt-6 text-sm text-muted/80 tracking-wide" data-id="element-296" data-mp="11xwhicht8j6q">
              Pago seguro · Modalidad online · Primera edición limitada
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}